export default "__VITE_ASSET__B1x2iARl__"